module.exports = __webpack_public_path__ + "static/twitter-eefbd3c5a205b7329d15fd3250582500.png";